'use strict';

var Backbone = require('backbone');

var Question = require('../models/question').default;

export default Backbone.Collection.extend({

  model: Question,
  comparator: 'sort_order',
});
